import { gql } from 'graphql-request';

export default gql`query vacancies($filter: VacanciesFilterInput, $pageSize: Int = 10, $currentPage: Int = 1) {
    vacancies(filter: $filter, pageSize: $pageSize, currentPage: $currentPage) {
        total_count
        pageInfo {
            currentPage
            endPage
            hasNextPage
            hasPreviousPage
            pageSize
            startPage
        }
        items {
            vacancy_id
            enabled
            name
            content
            location
            image
            gallery {
                url
            }
            url_key
            created_at
        }
    }
}`;